import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../redux-toolkits/store'

export const useAppDispatch: () => AppDispatch = useDispatch
